import axios from '../util/axiosconfig';
// auth/login
// export const loginApi = async (email: string, password: string,token: string ) => {
export const loginApi = async (userEmail: string, password: string ) => {
  const response = await axios.post('auth/login', {
    // email,
    userEmail,
    password,
    // headers: {
    //     Authorization: `Bearer ${token}`,  // Add the token to the Authorization header
    //   },
      
      
    });
    
    // const token = response.data.token;
    return response.data;
  };

export class AuthAPIS{
  login(userEmail: string, password: string ) {
    return axios.post('auth/login', {
      // email,
      userEmail,
      password,
      // headers: {
      //   Authorization: `Bearer ${token}`,  // Add the token to the Authorization header
      // },
  
  
    });
  }
}